import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { AppConfigService } from './app-config.service';
import { GeneralSetting } from '../models/general-setting.model';

@Injectable({
  providedIn: 'root'
})
export class GeneralSettingsService {
    private baseApiUrl: string;
    private baseAuthenticatedApiUrl: string;

    constructor(
        private httpService: HttpClient,
        private readonly configService: AppConfigService
    ){
        this.baseApiUrl = this.configService.getConfig().baseApiUrl;
        this.baseAuthenticatedApiUrl = `${this.baseApiUrl}Auth/`;
    }

    getGeneralSettingByKey(token: string, key: string): Promise<GeneralSetting> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': token
            })
        };
        return new Promise((resolve, reject) => {
            this.httpService.get<GeneralSetting>(`${this.baseAuthenticatedApiUrl}GeneralSettings/${key}`, httpOptions)
              .subscribe({
                next: (result: GeneralSetting) => {
                    resolve(result);
                },
                error: (error) => {
                    reject(error);
                }
            });
        });
    }
}